import { render, staticRenderFns } from "./ReferInternalFriend.vue?vue&type=template&id=4e9860a0&"
import script from "./ReferInternalFriend.vue?vue&type=script&lang=ts&"
export * from "./ReferInternalFriend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports